/**
 * #1987 — the one class string every floating pill shares (Ask Crosbot, Log
 * visit, New sample). This is the pill's own shape only; position, bottom
 * edge and z-index belong to FloatingPillRail (#2603) so a caller renders
 * a pill and declares nothing about where it sits.
 *
 * #5114: min-h-11 keeps a 44 px tap target when the label is hidden (Ask
 * Crosbot below sm is the icon alone, 40 px tall without it). A pill with
 * its label showing is 44 px already, so it does not change.
 */
export const FLOATING_PILL_CLASS =
  "flex min-h-11 items-center gap-2 rounded-full bg-primary px-4 py-3 text-sm font-medium text-primary-foreground shadow-lg transition hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2";
